if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.infoButton = this.querySelector('.quantity-popover__info-button');
        this.closeButton = this.querySelector('.button-close');
        this.info = this.querySelector('.quantity-popover__info');
        this.quantityInput = this.querySelector('.quantity__input');
        this.abortController = null;

        if (this.infoButton) {
          this.infoButton.addEventListener('click', this.togglePopover.bind(this));
        }
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.togglePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        const expanded = this.infoButton.getAttribute('aria-expanded') === 'true';
        this.infoButton.setAttribute('aria-expanded', !expanded);
        this.info.toggleAttribute('hidden');

        if (!expanded) {
          this.abortController = new AbortController();
          document.addEventListener('click', this.closePopover.bind(this), {
            signal: this.abortController.signal,
          });
        } else {
          this.abortController?.abort();
        }
      }

      closePopover(event) {
        if (!this.contains(event.target)) {
          this.infoButton.setAttribute('aria-expanded', 'false');
          this.info.setAttribute('hidden', '');
          this.abortController?.abort();
        }
      }
    }
  );
}
